import {
  RESET_ANALYSIS,
  UPDATE_ANALYSIS_PARAMS,
  SET_ANALYSIS,
  DELETE_RESULTS,
} from "../actions/types";
import { resultsKeys } from "../utils/resultsKeys";
// import { createResultsPV } from "../testData/createResultsPV";
// import { createResultsWT } from "../testData/createResultsWT";
// import { createResultsPVWT } from "../testData/createResultsPVWT";

const initialState = {
  id: null, // default null
  // for testing purposes below (select manually an id not null)
  // ...createResultsPV(),
  // ...createResultsWT(),
  // ...createResultsPVWT(),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_ANALYSIS_PARAMS:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case SET_ANALYSIS:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_ANALYSIS:
      return {
        ...initialState,
      };
    case DELETE_RESULTS:
      const stateWOResults = { ...state };
      resultsKeys.forEach((key) => {
        delete stateWOResults[key];
      });
      return stateWOResults;

    default:
      return state;
  }
}
